'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function rangeRight(start, end) {
    var step = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    if (end == null) {
        end = start;
        start = 0;
    }
    if (!Number.isInteger(step) || step === 0) {
        throw new Error("The step value must be a non-zero integer.");
    }
    var length = Math.max(Math.ceil((end - start) / step), 0);
    var result = new Array(length);
    for(var i = 0; i < length; i++){
        result[i] = start + (length - i - 1) * step;
    }
    return result;
}
exports.rangeRight = rangeRight;
